/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageModel } from '../../models/language-model';
import { LanguageUpdateModel } from '../../models/language-update-model';

export interface PutApiLanguageV1Id$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: LanguageUpdateModel
}

export function putApiLanguageV1Id$Plain(http: HttpClient, rootUrl: string, params: PutApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
  const rb = new RequestBuilder(rootUrl, putApiLanguageV1Id$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LanguageModel>>;
    })
  );
}

putApiLanguageV1Id$Plain.PATH = '/private/v1/languages/{id}';
